// extracted by mini-css-extract-plugin
export var chip = "_4f-0";
export var filterDropdown = "_4f-5";
export var filterItem = "_4f-6";
export var icon = "_4f-1";
export var removeButton = "_4f-3";
export var removeIcon = "_4f-4";
export var separator = "_4f-2";